<template>
  <a-form layout="vertical" :model="formState" ref="formRef">
    <ActionPicker
      v-if="node"
      isDefaultOption
      :node="node"
      :parentNode="parentNode"
      :disabled="disabled"
    />
  </a-form>
</template>

<script setup lang="ts">
import { provide, reactive, ref } from "vue";
import { FormInstance } from "ant-design-vue";

import { CreateNodeBody, Node } from "@/@types/ivr";
import { DrawerFormStateKey } from "@/@types/ivr/symbols";

import ActionPicker from "@/app/ivr/bot/components/pickers/ActionPicker.vue";

defineProps<{
  node?: Node;
  parentNode?: Node;
  disabled?: boolean;
}>();

const formRef = ref<FormInstance>();
const formState = reactive<Partial<CreateNodeBody>>({});

provide(DrawerFormStateKey, formState);

defineExpose({ formState, formRef });
</script>
